<template>
  <div class="evaluate-item">
    <div class="user-info">
      <div class="avatar">
        <img :src="info.user_avatar | imgZip(100)" alt="头像" />
        <span class="name">{{ info.user_name }}</span>
      </div>
      <div class="star">
        <van-rate
          v-model="info.score"
          :size="16"
          color="#FFBC49"
          void-icon="star"
          void-color="#eee"
          readonly
        />
      </div>
    </div>
    <div class="content">
      <YxlMore
        :lineClamp="4"
        :info="info.content"
        @hook:updated="yxlMoreUpdated"
      ></YxlMore>
    </div>
    <div class="tag-list" v-if="info.label.length">
      <div class="tag" v-for="(item, index) in info.label" :key="index">
        {{ item }}
      </div>
    </div>
    <HandList
      :style="{ 'margin-top': '0.2rem' }"
      :info="{
        like_num: info.zan_num,
        day: info.rate_time,
        likeState: info.zan_status
      }"
      :show="isShowHand"
      @setLike="setLike"
    ></HandList>
  </div>
</template>
<script>
import { Rate } from 'vant'
import YxlMore from 'component/common/yxlMoreNew.vue'
import HandList from 'component/platform/homepage/common/handList.vue'
import { imgZip } from 'app/web/filters/ossImg.js'
import { ratezan } from 'api/platform/homepage.js'

export default {
  props: {
    info: {
      type: Object,
      default: () => {
        return {}
      }
    },
    // 组件使用在哪个tab
    tab: {
      type: String
    }
  },
  components: {
    YxlMore,
    HandList,
    [Rate.name]: Rate
  },
  data() {
    return {
      isShowHand: {
        like: true,
        day: true,
        comment: false,
        share: false
      }
    }
  },
  computed: {
    basicInfo() {
      return this.$store.state.homepage.basicInfo || {}
    },
    // 是否专业咨询师
    zxProTeacher() {
      let { identities } = this.basicInfo
      identities = Array.isArray(identities) ? identities : []
      return identities.find(item => item.business === 'zixun_pro_teacher')
    }
  },
  created() {},
  mounted() {},
  methods: {
    imgZip,
    setLike() {
      const data = {
        id: this.info.id || ''
      }
      ratezan(data).then(({ code, message }) => {
        if (code === 0) {
          if (+this.info.zan_status === 1) {
            this.$toast('取消点赞成功')
            this.tab === 'homepageServiceTab' &&
              this.$trackEvent(
                'newprofilepages_consulttab_cancellikeevaluate',
                {}
              )
            this.$store.commit('homepage/UPDATE_RATE', {
              ...this.info,
              zan_num: Math.max(this.info.zan_num - 1, 0),
              zan_status: 0
            })
            // 埋点
            this.$trackEvent('newprofilepages_evaluate_like_cancel', {})
          } else {
            this.$toast('点赞成功')
            this.tab === 'homepageServiceTab' &&
              this.$trackEvent('newprofilepages_consulttab_likeevaluate', {})
            this.$store.commit('homepage/UPDATE_RATE', {
              ...this.info,
              zan_num: this.info.zan_num + 1,
              zan_status: 1
            })
            // 埋点
            this.$trackEvent('newprofilepages_evaluate_like', {})
          }
        } else {
          this.$toast(message)
        }
      })
    },
    yxlMoreUpdated() {
      this.$emit('updated')
    }
  }
}
</script>
<style lang="scss" scoped>
.evaluate-item {
  width: 100%;
  padding: 30px;
  margin-bottom: 30px;
  box-sizing: border-box;
  background: #ffffff;
  box-shadow: 0px 0px 40px 0px #ebefff;
  border-radius: 30px;
  overflow: hidden;
  .user-info {
    display: flex;
    align-items: center;
    .avatar {
      display: flex;
      align-items: center;
      img {
        width: 50px;
        height: 50px;
        border-radius: 50%;
        object-fit: cover;
      }
      .name {
        margin-left: 10px;
        font-size: 24px;
        color: #21252d;
      }
    }
    .star {
      margin-left: auto;
    }
  }
  .content {
    margin-top: 15px;
    font-size: 28px;
    color: #6c798c;
    line-height: 49px;
  }
  .tag-list {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    margin-top: 15px;
    .tag {
      padding: 6px 13px;
      background: #f2f4ff;
      border-radius: 10px;
      font-size: 20px;
      color: #21252d;
      line-height: 1.3;
      margin-bottom: 10px;
      &:not(:last-child) {
        margin-right: 10px;
      }
    }
  }
}
</style>
